module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-to-primitive/helpers/isPrimitive.js
 ** module id = 882
 ** module chunks = 0
 **/